import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-border py-12 mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
          <div>
            <Link to="/" className="font-serif text-2xl font-black tracking-tight">Inkspot<span className="text-muted-foreground">.</span></Link>
            <p className="mt-2 text-xs text-muted-foreground max-w-xs leading-relaxed">
              A premium, discovery-driven publishing platform for serious writers and curious readers.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-10 md:gap-16">
            <div className="space-y-4">
              <div className="eyebrow text-[10px] text-muted-foreground">Platform</div>
              <ul className="space-y-2 text-sm font-medium">
                <li><Link to="/explore" className="hover:underline">Explore</Link></li>
                <li><Link to="/articles" className="hover:underline">Articles</Link></li>
                <li><Link to="/authors" className="hover:underline">Authors</Link></li>
              </ul>
            </div>

            <div className="space-y-4">
              <div className="eyebrow text-[10px] text-muted-foreground">Company</div>
              <ul className="space-y-2 text-sm font-medium">
                <li><Link to="/about" className="hover:underline">About Us</Link></li>
                <li><Link to="/contact" className="hover:underline">Contact</Link></li>
              </ul>
            </div>

            <div className="space-y-4 col-span-2 sm:col-span-1">
              <div className="eyebrow text-[10px] text-muted-foreground">Legal</div>
              <ul className="space-y-2 text-sm font-medium">
                <li><Link to="/privacy" className="hover:underline">Privacy Policy</Link></li>
                <li><Link to="/terms" className="hover:underline">Terms of Service</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-border flex flex-col sm:flex-row justify-between items-center gap-4 text-[10px] uppercase tracking-widest text-muted-foreground font-bold">
          <div>© {new Date().getFullYear()} Inkspot. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <div className="h-1 w-1 bg-border rounded-full" />
            <span>Built for the modern web</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
